export default function addonProduct(productId, features, name, icon, price) {
  const parsePrice = (price) => {
    if (!price) {
      return {
        price: null,
        originalPrice: null,
        priceAsString: null,
        originalPriceAsString: null,
      };
    }

    return price.defaultIncludeVat
      ? {
          price: price.priceInclVat,
          originalPrice: price.renewalPriceInclVat,
          priceAsString: price.priceInclVatAsString,
          originalPriceAsString: price.renewalPriceInclVatAsString,
        }
      : {
          price: price.priceExclVat,
          originalPrice: price.renewalPriceExclVat,
          priceAsString: price.priceExclVatAsString,
          originalPriceAsString: price.renewalPriceExclVatAsString,
        };
  };

  const hasRebate = (price) => {
    if (price.price < price.originalPrice) {
      return true;
    }
    return false;
  };

  const isFree = (price) => {
    if (price.price === 0) {
      return true;
    }
    return false;
  };

  const setPrice = (price) => {
    return price.priceAsString;
  };

  const setOriginalPrice = (price) => {
    return price.originalPriceAsString;
  };

  const setCurrency = (price) => {
    return "";
  };

  const addonProduct = {
    id: productId,
    name: name,
    icon: icon,
    price: "",
    originalPrice: "",
    currency: "",
    hasRebate: false,
    isFree: false,
    features: features || [],
    rawPrices: {},
    type: "addonProduct",

    get productPrice() {
      return price;
    },

    set productPrice(price) {
      const parsedPrice = parsePrice(price);
      this.price = setPrice(parsedPrice);
      this.originalPrice = setOriginalPrice(parsedPrice);
      this.currency = setCurrency(parsedPrice);
      this.hasRebate = hasRebate(parsedPrice);
      this.isFree = isFree(parsedPrice);
      this.rawPrices = price;
    },
  };

  addonProduct.productPrice = price;

  return addonProduct;
}
